import React, { useCallback } from 'react';
import { Button } from '@tanium/react-button';
import { useAuthenticatedApiContext } from '../api/useApiClient';

interface DownloadLinkProps {
  href: string;
  name: string;
}
export const DownloadLink: React.FC<DownloadLinkProps> = ({ href, name, children }) => {
  const apiClient = useAuthenticatedApiContext();
  const onDownload = useCallback(async () => {
    const blob = await apiClient.downloadFile(href);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }, [href, name, apiClient]);

  return (
    <Button variant="link" onClick={onDownload} role="button">
      {children}
    </Button>
  );
};
